import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: #fff;
`;

const OnlineOrderClosed = () => {
  const hours = "Mon–Thu 5pm–9pm | Fri–Sun 11:30am–2pm, 5pm–9pm";

  return (
    <Page>
      <h2 style={{ color: '#e1d6c0' }}>Online Order Pickup is closed right now.</h2>

      <p><strong>Store Hours:</strong> {hours}</p>

      <p>Please return when the store is open so we can process your order.</p>

      <p>
        Return to the <Link to="/">Homepage</Link> or browse the <Link to="/menu">Menu</Link>.
      </p>
    </Page>
  );
};

export default OnlineOrderClosed;
